/* eslint-disable no-unused-vars */
import './device-detail.scss';
import {inject, observer} from 'mobx-react';
import React, {useContext, useLayoutEffect, useEffect, useMemo, useRef, useState} from 'react';
import moment from 'moment';
import {toJS} from 'mobx';
import styled from 'styled-components';
import {ThemeContext} from '../../../apiContexts';
import {DeviceInfoStyle} from '../styles';
import Actions from './actions';
import Driver from './driver';
import Header from './header';
import Location from './location';
import Contact from './contact';
import DeviceInfoAttributes from '../../../components/device-info-attributes';
import useTimezone from '../../../hooks/use-timezone';
import I18nMessage from '../../../components/I18nMessage';
import {getSnapshot} from 'mobx-state-tree';
import {trigger} from '../../../helpers/events';
import {v4 as uuid} from 'uuid';
import DeviceImagesOverlay from 'src/views/device/device-images-overlay.jsx';
import {useIntl} from 'react-intl';
import {timezoneFormat} from '../../../helpers/date';
import IconButton from 'src/autobahn/components/button/icon-button';
import Collapsible from 'src/autobahn/components/collapsible';
import useFormatter from 'src/hooks/user-formatter';
import useStore from 'src/hooks/use-store';

const Hr = styled.hr`
  width: calc(100% - 2rem);
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

const SinisterCreateButton = styled.button` 
   color: #FDA700;
   border-color: #FDA700;
   font-weight: 700;
   font-size: 16px;
   line-height: 19px;
   border-radius: 8px;
   margin: 10px;
   height: 40px;
`;

const Container = styled.div`
  /* height: 100%; */
  position: absolute !important;
  z-index: 6;
  /* padding-bottom: 1.5rem; */
  background-color: #fff;
  display: flex;
  flex-grow: 0;
  flex-direction: row;
  justify-content: flex-end;
  border-radius: 12px;
  max-height: calc(100% - 24px);
`;

const SpanSinisterInfo = styled.span`
  font-weight: 600;
  font-size: 12px;
  color: #6B6B6B;
`;

const SpanSinister = styled.span`
  font-weight: 700;
  font-size: 16px;
  color: #FDA700;
`;

const Btn = ({open = false, onClick = () => {}}) => {
  return (
    <div className='more-info__btn__container'>
      <IconButton className='more-info__btn' onClick={onClick}>
        <i className='fas fa-chevron-right more-info__btn__icon' data-open={open}></i>
      </IconButton>
    </div>
  );
};

const DeviceDetail = ({
  selected = {},
  server,
  toggleTrace,
  trace,
  createGeofence,
  followToogle,
  follow,
  driver,
  customer,
  session,
  sinisterStore,
  deviceStore,
  eventPosition,
}) => {
  const {name, uniqueId, status, attributes, id: deviceId} = selected;
  const currentPosition = posicaoDoCard(eventPosition, selected);
  const intl = useIntl();
  const {timezone} = useTimezone();
  const theme = useContext(ThemeContext);
  const [openedSinister, setOpenenSinister] = useState(undefined);
  const isOpenSinister = attributes.hasOwnProperty('sinisterId');
  const sliderRef = useRef(null);
  const imagesOverlayRef = useRef(null);
  const [isMoreInfoVisible, setMoreInfoVisible] = useState(false);
  const [images, setImages] = useState([]);
  const [selectedDeviceImage, selectDeviceImage] = useState(null);
  const selectedDeviceImageIndex = useMemo(() =>
          images.findIndex((img) => img === selectedDeviceImage),
  [selectedDeviceImage, images]);
  const imagesExists = images.length > 0;

  const {formatValue} = useFormatter();
  const {store} = useStore();

  const getAttributeLabel = (key) => {
    const m = key.match(/^(in|out)(\d+)$/i);
    if (m) {
      const baseKey = m[1].toLowerCase() === 'in' ? 'positionIn' : 'positionOut';
      return intl.formatMessage({id: baseKey, defaultMessage: m[1]}) + ' ' + m[2];
    }
    return store.positionAttributes.getAttributeName(key, true);
  };

  const safeFormatValue = (key, value) => {
    if (value === null || value === undefined) return '—';
    if (typeof value === 'object') {
      try {
        return JSON.stringify(value);
      } catch {
        return '—';
      }
    }
    try {
      return formatValue(key, value);
    } catch {
      return String(value);
    }
  };

  const onPressDeviceImage = (img) => () => {
      imagesOverlayRef.current.open(img);
  };

  const openSinister = () =>{
    trigger('openSinister:click');
    const currentPositionSnapshot = getSnapshot(currentPosition);
    const selectedSnapshot = getSnapshot(selected);
    const customerSnapshot = getSnapshot(customer);
    sinisterStore.newSinister(currentPositionSnapshot, selectedSnapshot, customerSnapshot, session);
  };

  const toggleMoreInfoVisibility = () => {
    setMoreInfoVisible((prev) => !prev);
  };

  const snapDeviceImagesSlideToLeft = () => {
      if (selectedDeviceImageIndex <= 0) return;

      const nextIndex = selectedDeviceImageIndex - 1;

      selectDeviceImage(images[nextIndex]);
      sliderRef.current.scrollTo({left: sliderRef.current.offsetWidth * nextIndex, behavior: 'smooth'});
  };

  const snapDeviceImagesSlideToRight = () => {
      if (selectedDeviceImageIndex >= images.length -1) return;

      const nextIndex = selectedDeviceImageIndex + 1;

      selectDeviceImage(images[nextIndex]);
      sliderRef.current.scrollTo({left: sliderRef.current.offsetWidth * nextIndex, behavior: 'smooth'});
  };

  useEffect(() => {
    if (deviceStore?.selectedDevice?.id) {
      deviceStore.selectedDevice.findImages().then((_images) => {
        setImages(_images.map((image) => ({
          id: uuid(),
          preview: image,
        })));
      });
    }
  }, [deviceStore.selectedDevice?.id]);

  useEffect(() => {
    if (imagesExists) {
      selectDeviceImage(images[0]);
    }
  }, [imagesExists]);

  useLayoutEffect(() => {
    if (isOpenSinister) {
      setOpenenSinister(toJS(sinisterStore.findById(attributes.sinisterId)));
    } else {
      setOpenenSinister(undefined);
    }
  }, [isOpenSinister, attributes.sinisterId, sinisterStore]);

  return (
    <Container>
      <div data-open={isMoreInfoVisible} className="device-card">
        <Header {...{...selected, theme}} server={server}/>
        <Contact contact={selected.contact} theme={theme} customer={customer}/>
        <Location
          theme={theme}
          currentPosition={currentPosition}
          timezone={timezone}
        />
        <Driver theme={theme} driver={driver}/>
        {/* <Pictures theme={theme}/> */}
        <Hr/>
        <DeviceInfo currentPosition={currentPosition} theme={theme} />
        <Hr/>
        <Actions
          traceToggle={toggleTrace}
          trace={trace}
          follow={follow}
          followToogle={followToogle}
          createGeofence={createGeofence}
          deviceUniqueId={uniqueId}
          isTag={selected.isTag()}
          deviceId={deviceId}
        />
        {!isOpenSinister ? <SinisterCreateButton
            className={'btn btn-sinister'}
            onClick={openSinister}>
          <i className="fas fa-shield-alt"/> <I18nMessage id="sinisterCreate"/>
        </SinisterCreateButton> :
        <SpanSinisterInfo><SpanSinister><i className={'fa fa-shield'}/> <I18nMessage id="sinisterOpen"/></SpanSinister>
          {!!openedSinister?.openingDate && moment(timezoneFormat(timezone, openedSinister.openingDate)).format(intl.formatMessage({id: 'dateTimeLongFormat'}))}
        </SpanSinisterInfo>}
      </div>

      <Collapsible open={isMoreInfoVisible} orientation='horizontal'>
        <>
          <hr style={{backgroundColor: '#E6E6E6', height: '80%', borderWidth: 0, borderStyle: 'solid', borderRightWidth: 'thin', borderColor: 'rgba(0, 0, 0, 0.12)'}} />
          <div className='more-info__container'>
            <div className='section'>
              <span className='section__title'>{intl.formatMessage({id: 'deviceVehicleImage'})}</span>

              {imagesExists ? (
                <>
                  <div className='images-slider' ref={sliderRef}>
                      {images.map((img) => (
                          <div key={`${img.id}_slide`} className='images-slider__slide'>
                              <img className='images-slider__slide__image' src={img.preview} onClick={onPressDeviceImage(img)} />
                          </div>
                      ))}
                  </div>

                  <div style={{display: 'flex', flexGrow: 0, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', alignSelf: 'stretch'}}>
                      <IconButton
                          className='slider__nav-button'
                          onClick={snapDeviceImagesSlideToLeft}
                          data-disabled={selectedDeviceImageIndex === 0}
                          disabled={selectedDeviceImageIndex === 0}
                          style={{marginRight: '24px'}}
                      >
                          <i className="fas fa-chevron-left fa-sm" color="inherit"></i>
                      </IconButton>

                      <div style={{display: 'flex', flexGrow: 0, flexDirection: 'row', columnGap: '16px'}}>
                          {images.map((img) => {
                              const selected = img === selectedDeviceImage;

                              return (
                                  <div key={`${img.id}_indicator`} className="slider__nav-indicator" data-active={selected} />
                              );
                          })}
                      </div>

                      <IconButton
                          className='slider__nav-button'
                          onClick={snapDeviceImagesSlideToRight}
                          data-disabled={selectedDeviceImageIndex === images.length - 1}
                          disabled={selectedDeviceImageIndex === images.length - 1}
                          style={{marginLeft: '24px'}}
                      >
                          <i className="fas fa-chevron-right fa-sm" color="inherit"></i>
                      </IconButton>
                  </div>
              </>
              ) : (
                <span style={{color: '#707070', fontSize: '0.8rem', lineHeight: '1rem'}}>{intl.formatMessage({id: 'deviceVehicleImageEmpty'})}</span>
              )}

              <span className='section__title' style={{paddingTop: '16px'}}>{intl.formatMessage({id: 'deviceMoreInfo'})}</span>


              <PositionAttributesList
                  attributes={currentPosition?.attributes}
                  intl={intl}
                  getAttributeLabel={getAttributeLabel}
                  safeFormatValue={safeFormatValue}
              />
            </div>
          </div>
        </>
      </Collapsible>

      <Btn open={isMoreInfoVisible} onClick={toggleMoreInfoVisibility} />

      <DeviceImagesOverlay
          ref={imagesOverlayRef}
          images={images}
      />
    </Container>
  );
};

export const PositionAttributesList = ({attributes, intl, getAttributeLabel, safeFormatValue}) => {
  const attributeEntries = attributes ? Object.entries(attributes) : [];

  if (attributeEntries.length === 0) {
    return (
      <span style={{color: '#707070', fontSize: '0.8rem', lineHeight: '1rem'}}>
        {intl.formatMessage({id: 'deviceNoMoreInfo'})}
      </span>
    );
  }

  return attributeEntries.map(([key, value]) => (
    <div key={key} style={{width: '100%', borderTop: '1px solid #ccc', paddingTop: '8px'}}>
      <div style={{display: 'flex', alignItems: 'flex-start', gap: '8px'}}>
        <span style={{
          fontWeight: 700,
          color: '#707070',
          textAlign: 'left',
          wordBreak: 'break-word',
          flex: '0 0 45%',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}>
          {getAttributeLabel(key)}
        </span>
        <span style={{
          flex: '1 1 auto',
          minWidth: 0,
          color: '#707070',
          textAlign: 'right',
          overflowWrap: 'anywhere',
        }}>
          {safeFormatValue(key, value)}
        </span>
      </div>
    </div>
  ));
};

const DeviceInfo = ({theme, currentPosition}) => (
  <DeviceInfoStyle id="deviceInfo" theme={theme}>
    <span><I18nMessage id="deviceInfoTitle"/></span>
    <DeviceInfoAttributes currentPosition={currentPosition} theme={theme} />
  </DeviceInfoStyle>
);

// Com um evento aberto o card mostra a posicao daquele instante; fora dele, a posicao atual do
// veiculo. O objeto vazio evita que a tela quebre enquanto nenhuma das duas existe.
export const posicaoDoCard = (eventPosition, device) =>
  eventPosition || (device && device.currentPosition) || {};

const mapping = ({store}) => ({
  selected: store.events.currentDevice,
  // Com um evento aberto, o card mostra a posicao daquele instante, nao a atual do veiculo.
  eventPosition: store.events.current ? store.events.position : null,
  server: store.server,
  map: store.map,
  session: store.session,
  sinisterStore: store.sinisterStore,
  deviceStore: store.devices,
});

export default inject(mapping)(observer(DeviceDetail));
